import React, { useState, useContext } from "react";
import styles from './style'
import { useTheme } from '@mui/material';
import Pool from "../UserPool";
import UserContext from '../ContextUser/Context';
import { CognitoUser } from "amazon-cognito-identity-js";
import { SuccessUpdate } from "../SuccessUpdate";
import { Container, Typography, Grid, TextField, Dialog } from '@mui/material';
import { InputCodigoVerificacion, InputPassword, Button, Link } from "@alquiler-argentina/aa-componentes";
import AACargando from '../../Commons/AACargando';
import Footer from '../Footer';
import isMobile from 'ismobilejs';
import ModalCloseIcon from '../ModalCloseIcon';
import axios from 'axios';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import validator from 'validator';
import * as Sentry from '@sentry/react';


export default function UpdatePassword({ modalOpen, onCloseLoginModal, userEmail, forgotPassword, createAnfitrion, esTroya, tipo }) {
  const theme = useTheme()
  const classes = styles(theme);
  const userEmailParameter = window.g && window.g.email ? window.g.email : false;
  const [Username, setEmail] = useState(userEmail || userEmailParameter || "");
  const [updateStatus, setUpdate] = useState(false);
  const [passwordDisabled, setPasswordInput] = useState(false);
  const [stateEmail, setStateEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [verification, setVerification] = useState("")
  const [loading, setLoading] = useState(false);
  const [verificationFailed, setFailed]= useState(false);
  const [errorEmail, setErrorEmail]= useState(false);
  const [errorPassword, setErrorPassword]= useState(false);
  const { authenticate, state } = useContext(UserContext);
  const forgotAnfitrion = window.g && window.g.forgot ? window.g.forgot : false;
  const email = Username;

  /// Esta función envia el código de verificación al mail y comienza el flujo ///
  const user = new CognitoUser({Username, Pool})
  const onSubmit = async () => {
    setLoading(true);
    if(!validator.isEmail(Username)){ 
      setErrorEmail(true)
      setLoading(false)
      return false
    }
    setStateEmail(true);
    user.forgotPassword({
      onSuccess: function(data) {
        setLoading(false);
      },
      onFailure: function(err) {
        Sentry.captureException(err, 'Something is wrong with UpdatePassword, function onSubmit');
        alert(err.message || JSON.stringify(err));
        setLoading(false);
      },
    });
  };


  /// Esta función toma el valor del inputCodigoVerificacion y verifica que sea correcto ///
  const codeVerify = () => {
    setLoading(true)
    if(password.length < 8){
      setErrorPassword(true)
      setLoading(false)
      return false
    }
    const verificationCode = verification;
    const newPassword = password;
    user.confirmPassword(verificationCode, newPassword,{
      onSuccess(data) {
        axios.put(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/`, {
          updated_password: 1,
          email: Username
        })
        .then(() => {
          setUpdate(true)
          onInit()
          setLoading(false)
        })
        .catch((err) => console.log(err))
      },
      onFailure(err) {
        onSubmit()
        setVerification('------')
        setLoading(false)
        setFailed(true)
      },
    });
  }

  // Función que logea al usuario una vez actualizada la contraseña
  const onInit = () => {
    authenticate(email, password)
        .then( (data) => { 
        })
        .catch((err) => {
            Sentry.captureException(err, "Something is wrong UpdatePassword, function onInit");
        })
  }
  const handleBack = () =>{
    setStateEmail(false)
  }
  
  if(loading && !modalOpen){
    return <div css={classes.aaLoader}><AACargando /></div>
  }
  
  if(updateStatus && !forgotAnfitrion){ 
    return<SuccessUpdate email={Username} createAnfitrion={createAnfitrion ? true : false} esTroya={esTroya ? true : false} onCloseLoginModal={onCloseLoginModal} modalOpen={modalOpen} title="¡Contraseña actualizada!" subtitle="Gracias por actualizar la contraseña, ya podés ingresar al sitio con mayor seguridad." tipo={tipo} secondaryButton={tipo == 2 || tipo == 3 ? true : false} />
  }
  
  if(updateStatus && forgotAnfitrion || updateStatus && forgotPassword ){ 
    return<SuccessUpdate email={Username} createAnfitrion={createAnfitrion ? true : false} esTroya={esTroya ? true : false} onCloseLoginModal={onCloseLoginModal} modalOpen={modalOpen} title="¡Contraseña actualizada!" subtitle="Ahora podés buscar alojamiento para tu próximo destino, esperamos que disfrutes de viajar con Alquiler Argentina." secondaryButton={state.tipo == 2 || state.tipo == 3 ? true : false} />
  }

const updatePasswordContainer =
    <Container css={classes.container} component="main" maxWidth="xs">
      {loading ? <div css={classes.aaLoaderModal}><AACargando /></div> : null }
      {modalOpen && <ModalCloseIcon onClick={onCloseLoginModal} />}
      <div style={loading ? {display: 'none'} : null} css={classes.paper}>
      {stateEmail ? <div css={!modalOpen ? classes.containerIcon : ''}><IconButton css={modalOpen ? classes.backIcon : ''} onClick={handleBack}><ArrowBackIcon /></IconButton></div> : null}
        <Grid item xs={12}>
          <img src="https://img.alqastatic.com/_img_/isologo.png?w=48" alt="Logo AA" />
        </Grid>
        {!stateEmail ? (
          <div>
            <Typography
              variant="h5"
              css={classes.title}
              component="div"
            >
              {forgotAnfitrion || forgotPassword ? "¿Olvidaste la contraseña?" : "Actualizar contraseña"}
            </Typography>
            <Typography
              variant="body2"
              component="div"
              css={classes.subtitle}
            >
              {forgotAnfitrion || forgotPassword ? "¡No pasa nada! Podemos enviarte un código de verificacion para restablecer la contraseña. Ingresa el correo electrónico de la cuenta." : "Hemos mejorado la seguridad de la cuenta, por lo que necesitamos que crees una nueva contraseña. Te enviaremos un código de verificación por correo electrónico para actualizarla. " }
            </Typography>
            <Typography
            variant="body2"
            component="div"
            css={classes.subtitle}>
              Te enviaremos un código de verificación por correo electrónico para actualizarla. Si no recibiste el código en tu bandeja de entrada, revisá el correo no deseado o Spam.
            </Typography>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              type="email"
              error={errorEmail ? true : false}
              helperText={errorEmail ? 'Correo electrónico inválido' : ''}
              label="Correo electrónico"
              name="email"
              autoFocus
              autoComplete="email"
              value={Username}
              onChange={(event) => {setEmail(event.target.value);}}
            />
              <Button
                onClick={onSubmit}
                size='large'
                fullWidth
                variant="contained"
                color="primary"
                css={classes.submit}
              >
                Enviar código de verificacion
              </Button>
          </div>
        ) : (
          <div>
            <Typography
              variant="h5"
              css={classes.title}
              component="div"
            >
              Actualizá tu contraseña
            </Typography>
            <Typography
              variant="body2"
              component="div"
              css={classes.subtitle}
            >
              Ingresá el código de verificación que recibiste por correo
              electrónico en <span css={classes.boldFont}>{Username}</span>.
            </Typography>
            <Typography
            variant="body2"
            component="div"
            css={classes.subtitle}>
              Si no recibiste el código en tu bandeja de entrada, revisá el correo no deseado o Spam.
            </Typography>
            <div css={classes.inputCode}>
              <InputCodigoVerificacion error={verificationFailed ? true : false} placeholder='-' onCompleted={() => setPasswordInput(true)} onChange={(event) =>{setVerification(event)}} value={verification} length={6} />
              {verificationFailed ? (<Typography variant="body2" css={classes.verificationFail}>Código incorrecto. Hemos enviado un nuevo código a tu correo electrónico para que ingreses.</Typography>) : null}
            </div>
            <Typography
              variant="body2"
              component="div"
              css={classes.subtitle}
            >
              Creá tu nueva contraseña, utilizá 8
              caracteres como mínimo.
            </Typography>
            <InputPassword
              variant="outlined"
              required
              fullWidth
              name="password"
              label="Contraseña"
              error={errorPassword ? true : false }
              helperText={errorPassword ? 'Utilizá 8 caracteres para tu contraseña.' : ''}
              id="password"
              disabled={passwordDisabled ? false : true}
              value={password}
              onChange={(event) => {setPassword(event.target.value);}}
            />
            <form css={classes.form} noValidate>
              <Button
               onClick={codeVerify}
                size='large'
                fullWidth
                variant="contained"
                color="primary"
                css={classes.submit}
              >
                Crear nueva contraseña
              </Button>
            </form>
          </div>
        )}
        <Grid container direction='column' justifyContent="center" alignItems="center">
            <Grid item>
               <Typography>¿Necesitás ayuda?</Typography>
            </Grid>
            <Grid item>
               <Link href="https://api.whatsapp.com/send?phone=5491152638215">Escribir por Whatsapp</Link>
            </Grid>
        </Grid>        
      <Footer />
      </div>
    </Container>

  return (
    modalOpen ? (<Dialog scroll="body" fullScreen={isMobile.any} css={isMobile.any ? classes.modal : ''} onClose={onCloseLoginModal} open={modalOpen}>{updatePasswordContainer}</Dialog>) : updatePasswordContainer
  );
}
